import { FendiGeography } from '@qwentes/fendi/umd/geography';

export default class GeographyService extends FendiGeography {
  /* @ngInject */
  constructor(HttpService, AuthService, AUTH_CONSTANT) {
    super(window.__FHL__.host.retailMasterData, HttpService);
    this.httpService = HttpService;
    this.authService = AuthService;
    this.AUTH_CONSTANT = AUTH_CONSTANT;
    this.store = {};
    // todo: test regionRestrictions
  }

  storeDetail(storeId, params = {}, headers = {}) {
    if (this.store.detail) {
      return this.httpService.resolve(this.store.detail);
    }
    const storeIdWithFallback = this.AUTH_CONSTANT.STORE_FALLBACK[storeId] || storeId;
    const options = {params: {...params, include: 'market,region'}, headers: {...headers}};
    return super.getStore(storeIdWithFallback, options)
      .then(({data}) => {
        this.store.detail = data;
        return this.store.detail;
      }, this.httpService.reject);
  }

  getActiveStores(marketId, params) {
    return super.getStores({
      params: {
        'filter[marketIds]': marketId,
        ...params,
      },
    })
    .then(({data}) => {
      return data;
    }, this.httpService.reject);
  }

  getRegions(options) {
    return super.getRegions(options)
      .then(res => res.data);
  }

  getMarkets(options) {
    return super.getMarkets(options)
      .then(res => res.data);
  }

  getStores(options) {
    return super.getStores(options)
      .then(res => res.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/geography/geography.service.js